<!-- Material Icons -->
<link
  rel="stylesheet"
  href="https://fonts.googleapis.com/icon?family=Material+Icons">
  <!-- Google Fonts -->
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>

<!-- Roboto -->
<link
  rel="stylesheet"
  href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,600,700"
/>
<!-- Roboto Mono -->
<link
  rel="stylesheet"
  href="https://fonts.googleapis.com/css?family=Roboto+Mono"
/>
<!-- Patrick Hand -->
<link href="https://fonts.googleapis.com/css2?family=Patrick+Hand&display=swap" rel="stylesheet">
<!-- Svelte theme -->
<link
  rel="stylesheet"
  href="https://cdn.jsdelivr.net/npm/svelte-material-ui/bare.min.css"
/>

<script>
	import Button from "@smui/button";
	import FormField from "@smui/form-field";
	import IconButton from "@smui/icon-button";
	import TopAppBar, {
		Section,
		Title,
		AutoAdjust,
	} from '@smui/top-app-bar';

	import "ag-grid-community/styles/ag-grid.css";
	import "ag-grid-community/styles/ag-theme-alpine-dark.css";

	import "./fbdComponents.css";

	import ViewTabSet from "./ViewTabSet.svelte";
	import ViewTab from "./ViewTab.svelte";


	import FbdClassRosterPreview from "./fbdClassRosterPreview";
	import FbdClassPendingPreview from "./fbdClassPendingPreview";

	import FbdClassRosterTooltip from "./fbdClassRosterTooltip";
	import FbdClassPendingTooltip from "./fbdClassPendingTooltip";


	import FbdClassInvitePanel from "./fbdClassInvitePanel";
	import FbdClassTimeReadout from "./fbdClassTimeReadout";
	import ClassInfoView from "./ClassInfoView.svelte";
	import AttemptsTable from "./AttemptsTable.svelte";

	import ClassControlDashboard from "./ClassControlDashboard.svelte";

	const searchParams = new URLSearchParams(window.location.search);
	const viewingClass = searchParams.get("class");

	export let auth = { signedin }, googleSignIn, msSignIn, onAuthChange;

	let user = null, displayName = "";
	let topAppBar, researchOn = [];

	const regUser = (tok) => {
		const headers = new Headers();

		headers.append('Authorization', tok);

		return fetch('/api/users/register/', {
			method: 'GET',
			headers: headers,
		})
	}

	let classesDataEnroll = undefined, classesDataTrial = undefined;
	let studentsPreviewEnroll = undefined, studentsPreviewTrial = undefined;
	let studentProgressData = [];

	let columnDefsEnroll = [
		{
			headerName: "Joined Students",
			field: "students_data",
			cellRenderer: FbdClassRosterPreview,

			tooltipField: "students_data",
			tooltipComponent: FbdClassRosterTooltip
		},
		{
			headerName: "Awaiting Students",
			field: "pending_students",
			cellRenderer: FbdClassPendingPreview,

			tooltipField: "pending_students",
			tooltipComponent: FbdClassPendingTooltip
		}
	];

	let columnDefsTrial = [
		{
			headerName: "Joined Students",
			field: "students_data",
			cellRenderer: FbdClassRosterPreview,

			tooltipField: "students_data",
			tooltipComponent: FbdClassRosterTooltip
		},
		{
			headerName: "Invite Code",
			field: "invite_code",
			cellRenderer: FbdClassInvitePanel
		},
		{
			headerName: "Invite Expiration",
			field: "code_expiry",
			cellRenderer: FbdClassTimeReadout
		}
	];


	let taskStatus = 'OK';
	let taskNotifs = [], taskRecs = [];
	let taskAddrsRetryFn = undefined;

	let invExpiryType = 'unuse';

	const msPerDay = 24 * 60 * 60000;

	const dateNow = new Date();
	const tDeltaZone = dateNow.getTimezoneOffset() * 60000;

	const tNowLocal = dateNow.getTime() - tDeltaZone;
	const tTomorrowLocal = tNowLocal + msPerDay;
	const tThreeMonthsLocal = tNowLocal + (90*msPerDay);

	const dateTomorrow = new Date(tTomorrowLocal);
	const dateThreeMonths = new Date(tThreeMonthsLocal);


	let isInstructor = false, isAdmin = false, hasEnrolls = false;


	let tskBlbParents = {
		breakroom: undefined,
		enrollClass: undefined,
		trialClass: undefined,
		classDashboardInvite: undefined,
		classDashboardReminder: undefined
	};

	let taskBlurbCard = undefined;

	let setTaskNotif = (status, messages, newParent=undefined, to=[], cc=[], bcc=[], retryAddrsCall=undefined) => {
		taskStatus = status;
		taskRecs = [to, cc, bcc];
		taskNotifs = messages;

		taskAddrsRetryFn = retryAddrsCall;
		
		console.log(`Attempting to move task notif card to ${newParent}`)

		if(newParent && newParent in tskBlbParents) {
			tskBlbParents[newParent].appendChild(taskBlurbCard);
		}
	}

	const taskStatusMap = {
		getStyle: (st) =>
			st.toUpperCase() in taskStatusMap.styles?
			taskStatusMap.styles[st.toUpperCase()]
			:
			taskStatusMap.styles.getFallback(st)
		,
		getBlurb: (st) =>
			st.toUpperCase() in taskStatusMap.blurbs?
			taskStatusMap.blurbs[st.toUpperCase()]
			:
			taskStatusMap.blurbs.getFallback(st)
		,

		// Tags lead the notification string and are always of length six -- four letters enclosed in angle braces
		// Avoid spaces before or directly after the tag.

		// For example, the below notif...
		// let notif = '<INFO>This notification will render with the neutral information style.'

		getNotifStyle: (n) => {
			const tag = n.substring(1, 5).toUpperCase();
			if(n.charAt(0) === '<' && n.charAt(5) === '>'){
				return tag.toUpperCase() in taskStatusMap.notifStyles?
				taskStatusMap.notifStyles[tag]
				:
				taskStatusMap.notifStyles.getFallback(n);
			}

			return '';
		},
		getNotifText: (n) => {
			const style = taskStatusMap.getNotifStyle(n);
			if(style) {
				return style !== taskStatusMap.notifStyles.getFallback(n)?
				n.substring(6)
				:
				`Type '${n.substring(1, 5)}': ${n.substring(6)}`
			}

			return n;
		},

		canRetry: (st) =>
			st.toUpperCase() === 'HALTED' && taskRecs[0].length > 0 && taskAddrsRetryFn
		,

		styles: {
			OK: 'invite-ok',
			HALTED: 'invite-warn',
			FAILED: 'invite-fail',
			TASKSUCCESS: 'invite-ok',
			TASKERROR: 'invite-fail',
			getFallback: (st) => 'invite-fail'
		},
		blurbs: {
			OK: 'Successfully sent!',
			HALTED: 'Task halted due to a recipient issue.',
			FAILED: 'Task failed.',
			TASKSUCCESS: 'Success!',
			TASKERROR: 'An error has occurred.',
			getFallback: (st) => `Task failed with unexpected status '${st}'`
		},
		notifStyles: {
			INFO: 'notif-notice',
			WARN: 'notif-warning',
			KILL: 'notif-critical',
			getFallback: (n) => 'notif-unknown'
		}
	};

	function getExistentIdPromise() {
		return new Promise(r => r(user.idToken));
	}

	onAuthChange((u) => {
		if (u) {
			console.log(u);

			u.getIdToken(true).then( (tok) => {
				user = {};
				user.displayName = u.displayName;
				user.uid = u.uid;
				user.idToken = tok;

				return regUser(tok);
			}).then(res => {
				if(!res.ok) {
					console.log(res.text());
					return new Promise((r) => r("Error fetching authorization"));
				}
				return res.json();
			}).then(data => {
				researchOn = data['research'];

				isInstructor = data['permissions_level'] > 0;
				isAdmin = data['permissions_level'] > 1;
				hasEnrolls = data['has_joined_enrollments'];

				const headers = new Headers();
				headers.append('Authorization', user.idToken);
				headers.append('Content-Type', "application/json");

				if(viewingClass){
					if(!isInstructor) {
						location.href = "/"
					}
				}
				else {
					if(isInstructor) {
						// Get teaching data once login token is fetched
						fetch('/api/teaching/enr_classes_data/', {headers: headers}).then(res => {
							if(!res.ok) {
								return res.text().then(tx => {
									console.log(tx);
									return [];
								});
							}
							return res.json();
						}).then(data => {
							classesDataEnroll = [];
							studentsPreviewEnroll = [];

							data.forEach(cl => {
								if(!"students_data" in cl) throw Error("BAD RESPONSE");
								const st_dt = cl['students_data'];

								classesDataEnroll.push(cl);
								studentsPreviewEnroll.push(st_dt);
							});

							classesDataEnroll = classesDataEnroll;
							studentsPreviewEnroll = studentsPreviewEnroll;
						});

						fetch('/api/teaching/trl_classes_data/', {headers: headers}).then(res => {
							if(!res.ok) {
								return res.text().then(tx => {
									console.log(tx);
									return [];
								});
							}
							return res.json();
						}).then(data => {
							classesDataTrial = [];
							studentsPreviewTrial = [];

							// Generate list of unique column names
							data.forEach(cl => {
								if(!"students_data" in cl) throw Error("BAD RESPONSE");
								const st_dt = cl['students_data'];

								classesDataTrial.push(cl);
								studentsPreviewTrial.push(st_dt);
							});

							classesDataTrial = classesDataTrial;
							studentsPreviewTrial = studentsPreviewTrial;
						});
					}

					if(hasEnrolls) {

						// Get teaching data once login token is fetched
						fetch('/api/teaching/student_progress/', {headers: headers}).then(res => {
							if(!res.ok) {
								return res.text().then(tx => {
									console.log(tx);
									return [];
								});
							}
							return res.json();
						}).then(data => {
							studentProgressData = data;
						});

					}
				}
            });
		} else {
			console.log("signed out");
			user = null;
		}
	});

	$: displayName = user? user.displayName :  "- please log in";

	function ensureSignature(pmt) {
		while(true) {
			const signature = window.prompt(pmt);

			if(!signature) return false;

			if(signature.length < 3) {
				alert("Please ensure your signature is at least three characters long.")
			}
			else {
				return signature;
			}
		}
	}

	let researchToggle = () => {
		if(researchOn) {
			if(ensureSignature(
`Are you sure you would like to opt out of the research study?

We will be unable to remove previously submitted data as it was anonymous, and you will need to log into the FBD Mobile App again to apply these changes. After you complete these steps, no further data will be sent to the research database.

By entering your name you confirm the above.`
			)) {
				getExistentIdPromise().then( (tok) => {
					const headers = new Headers();
					headers.append('Authorization', tok);

					return fetch('/api/users/consent/?consent=n', {
						method: 'GET',
						headers: headers,
					});
				}).then(() => {
					researchOn = false;
				});
			}
		} else if(ensureSignature(
"By entering your name below, you certify that you have read and agree to the informed consent terms linked on this page."
		)) {
			getExistentIdPromise().then( (tok) => {
				const headers = new Headers();
				headers.append('Authorization', tok);

				return fetch('/api/users/consent/?consent=y', {
					method: 'GET',
					headers: headers,
				});
			}).then(() => {
				researchOn = true;
			});
		}
	}

	let createAcademicClass = (stId="enrollClassStudentsField") => {
		const addrsElm = document.getElementById(stId);
		const nameElm = document.getElementById("enrollClassNameField");
		const doMailElm = document.getElementById("enrollClassDoMailField");

		let inv = addrsElm.value.toLowerCase();
		let nn = nameElm.value;
		let dm = doMailElm.checked? "TRUE" : "FALSE";

		getExistentIdPromise().then( (tok) => {
			const headers = new Headers();
			headers.append('Authorization', tok);
			headers.append('Content-Type', "application/json");

			const ls = JSON.stringify({
				class_name: nn,
				student_addresses: inv,
				do_mail: dm
			})

			fetch('/api/classes/new_class/', {method: 'POST', body: ls, headers: headers}).then(res => {
				const ct = res.headers.get('Content-Type');
				if(ct && ct.includes('application/json')) {
					return res.json();
				}

				return res.text();
			}).then(data => {
				if(typeof data !== 'string' && 'result' in data) {
					const res = data['result'];

					if(res === 'OK') {
						setTaskNotif('TASKSUCCESS', ["<INFO>Your new academic class has been created."], "enrollClass");
						new Promise(r => setTimeout(r, 3000)).then(() => {location.href = `?class=${data['class_id']}`;})
						return;
					}

					if('recipients' in data) {
						// Creation stopped because bad mail result
						const msgs = 'messages' in data && data.messages.length > 0? data.messages : undefined;
						setTaskNotif(res, msgs, "enrollClass",
								'recipients' in data? data.recipients : [],
								'recipients_cc' in data? data.recipients_cc : [],
								'recipients_bcc' in data? data.recipients_bcc : [],
								createAcademicClass
						);
						return;
					}

					// Unexpected
					window.alert(
`We're sorry, our system has encountered an unexpected error
${res}
on academic class creation.

Please try again later.`
					);
				}
				else {
					// Creation stopped because of auth or class-init issue
					setTaskNotif(
							'TASKERROR',
							[`<KILL>${typeof data === 'string'? data : JSON.stringify(data)}`],
							"enrollClass"
					);
				}
			});
		});
	}

	let createTrialClass = (stId="trialClassStudentsField") => {
		const addrsElm = document.getElementById(stId);
		const nameElm = document.getElementById("trialClassNameField");
		const expirElm1 = document.getElementById("trialClassExpiryVal");
		const expirElm2 = document.getElementById("trialClassExpiryDenom");
		const expirType = invExpiryType;

		let inv = addrsElm.value.toLowerCase();
		let nn = nameElm.value;

		let expirVal;
		if(expirType === 'date') {
			expirVal = new Date(expirElm1.value).toISOString().slice(0, -8);
		}
		else {
			expirVal = {};
			const expV = expirElm1.value;
			const expD = expirElm2.value;
			expirVal[expD] = expV
		}

		getExistentIdPromise().then( (tok) => {
			const headers = new Headers();
			headers.append('Authorization', tok);
			headers.append('Content-Type', "application/json");

			const ls = JSON.stringify({
				class_name: nn,
				invite_addresses: inv,
				expiry_mode: expirType,
				expiry_val: expirVal,
			})

			fetch('/api/classes/new_trial_class/', {method: 'POST', body: ls, headers: headers}).then(res => {
				const ct = res.headers.get('Content-Type');
				if(ct && ct.includes('application/json')) {
					return res.json();
				}

				return res.text();
			}).then(data => {
				if(typeof data !== 'string' && 'result' in data) {
					const res = data['result'];

					if(res === 'OK') {
						setTaskNotif('TASKSUCCESS', ["<INFO>Your new trial class has been created."], "trialClass");
						new Promise(r => setTimeout(r, 3000)).then(() => {location.href = `?class=${data['class_id']}`;})
						return;
					}

					if('recipients' in data) {
						// Creation stopped because bad mail result
						const msgs = 'messages' in data && data.messages.length > 0? data.messages : undefined;
						setTaskNotif(res, msgs, "trialClass",
								'recipients' in data? data.recipients : [],
								'recipients_cc' in data? data.recipients_cc : [],
								'recipients_bcc' in data? data.recipients_bcc : [],
								createTrialClass
						);
						return;
					}

					// Unexpected
					window.alert(
`We're sorry, our system has encountered an unexpected error
${res}
on trial class creation.

Please try again later.`
					);
				}
				else {
					// Creation stopped because of auth or class-init issue
					setTaskNotif(
							'TASKERROR',
							[`<KILL>${typeof data === 'string'? data : JSON.stringify(data)}`],
							"trialClass"
					);
				}
			});
		});
	}
</script>

<main>
	<TopAppBar bind:this={topAppBar} variant="fixed">
		<Section>
			<img src={"/logo.png"} alt="FBD Logo" height={40} />
			<Title>Free Body Diagram - Account Portal</Title>
		</Section>

	</TopAppBar>
	<AutoAdjust {topAppBar}>
		<div class="appContainer">

			<h1>Hello {displayName}!</h1>
			<a target="_blank" style="text-decoration: none" href="/for_ios" rel="noreferrer">
				<Button variant="raised"><span class="material-icons">info</span>Download for iOS</Button>
			</a>
			<a target="_blank" style="text-decoration: none" href="/for_android" rel="noreferrer">
				<Button variant="raised"><span class="material-icons">android</span>Download for Android</Button>
			</a>
			{#if user}
				{#if isAdmin}
					<a style="text-decoration: none" href="/admin">
						<Button variant="raised"><span class="material-icons">admin_panel_settings</span>Administrator Options</Button>
					</a>
				{/if}
				<Button variant="raised" on:click={auth.signOut()}><span class="material-icons">logout</span>Switch Accounts</Button>
				{#if viewingClass}

					<ClassControlDashboard
							idToken={user.idToken}
							{viewingClass}
							{searchParams}
							{isAdmin}
							{setTaskNotif}
					>
						<div slot="mailInvite" bind:this={tskBlbParents.classDashboardInvite}></div>
						<div slot="mailReminder" bind:this={tskBlbParents.classDashboardReminder}></div>
					</ClassControlDashboard>

				{:else}

					<h2>Please review the information below and scroll down for your login code</h2>
					<p class="consentText"><b>Informed Consent:</b> This application is part of a research study to improve the learning experience of students studying statics. Please find the full details of the study <a href="/resources">at this link</a>. Participation in the study is completely voluntary - you may use the application without participating in the study, and  you may withdraw from the study at any time by returning to this page and disabling the "research opt-in switch below".
					<br/><br/>As part of the study, anonymized details on your progress will be sent to a separate database than the one used to track your game progress. No identifying information will be collected, and this data will only be accessible to authorized researchers in compliance with research procedures approved by WPI's Institutional Review Board.</p>
					<b>Currently opted {researchOn ? "in to" : "out of"} research study</b><br/><br/>
					<FormField align="end">
						<Button variant="raised" on:click={researchToggle}>
							<span class="material-icons">history_edu</span> {researchOn ? "Opt Out" : "Opt In"}
						</Button>
					</FormField>
					<br/>
					<br/>

					<br/>

					{#if isInstructor || hasEnrolls}
						<ViewTabSet let:tabControl>
							{#if isInstructor}
								<ViewTab label="Academic Classes" {tabControl}>

									<ClassInfoView tableTitle="Your Academic Classes"
												   classesData={classesDataEnroll}
												   innerColumnDefs={columnDefsEnroll}
												   previewData={studentsPreviewEnroll}
									/>

									<br/>
									<h2>New Academic Classroom:</h2>
									<p>Use the form below to create a secure class with email authentication.</p>
									<form on:submit|preventDefault={() => createAcademicClass()}>
										<label for="enrollClassNameField">Enter a new class name (5 to 50 characters):</label>
										<input class="invite-entry" placeholder="" id="enrollClassNameField" type="text" required/>
										<p style="font-size: smaller; font-weight: bold">
											Your class name may only include letters, numbers, spaces, and the following punctuation:
											<span style="display: inline-block; font-family: Arial, sans-serif">. ' " - _ ~ ` ^</span>
										</p>
										<br/>
										<label for="enrollClassStudentsField">Optional -- Enter student emails to enroll (delimited by spaces):</label>
										<input class="invite-entry" placeholder="e.g. bhoneydew@wpi.edu beaker@gmail.com" id="enrollClassStudentsField" type="text"/>
										<div style="display: flex; align-items: center; justify-content: center">
											<label for="enrollClassDoMail" style="display: inline-block; margin-right: 0.4em">Include an email invitation:</label>
											<input class="invite-checkbox" id="enrollClassDoMailField" type="checkbox"/>
										</div>
										<p style="font-size: smaller; font-weight: bold; margin-top: 0.2em; margin-bottom: 1em">
											(You can do this later if you'd like!)
										</p>
										<div>
											<Button type="submit" id="enrollCreateConf" variant="raised">
												<span class="material-icons">post_add</span> Create classroom
											</Button>
										</div>
									</form>
									<div bind:this={tskBlbParents.enrollClass}></div>

								</ViewTab>
								<ViewTab label="Trial Classes" {tabControl}>

									<ClassInfoView tableTitle="Your Trial Classes"
												   classesData={classesDataTrial}
												   innerColumnDefs={columnDefsTrial}
												   previewData={studentsPreviewTrial}
									/>

									<br/>
									<h2>New Trial Classroom:</h2>
									<p>Use the form below to create a convenient, invite code-based demo class.</p>
									<form on:submit|preventDefault={() => createTrialClass()}>
										<label for="trialClassNameField">Enter a new class name (5 to 50 characters):</label>
										<input class="invite-entry" placeholder="" id="trialClassNameField" type="text" required/>
										<p style="font-size: smaller; font-weight: bold">
											Your class name may only include letters, numbers, spaces, and the following punctuation:
											<span style="display: inline-block; font-family: Arial, sans-serif">. ' " - _ ~ ` ^</span>
										</p>
										<br/>
										<label for="trialClassStudentsField">Optional -- Enter emails to invite (delimited by spaces):</label>
										<input class="invite-entry" placeholder="e.g. bhoneydew@wpi.edu beaker@gmail.com" id="trialClassStudentsField" type="text"/>

										<fieldset style="margin-bottom: 0.5em">
											<legend>Expire invite code...</legend>
											<div style="display: flex; justify-content: space-evenly">
												<div>
													<label for="invExpireUnuse">After a duration of unuse</label>
													<input type="radio" id="invExpireUnuse" on:click={() => invExpiryType = 'unuse'} name="trial-create-expiry"
														   checked/>
												</div>
												<div>
													<label for="invExpireLength">After a specific duration</label>
													<input type="radio" id="invExpireLength" on:click={() => invExpiryType = 'length'} name="trial-create-expiry"/>
												</div>
												<div>
													<label for="invExpireDate">At a set date and time</label>
													<input type="radio" id="invExpireDate" on:click={() => invExpiryType = 'date'} name="trial-create-expiry"/>
												</div>
											</div>
										</fieldset>

										{#if invExpiryType === 'unuse'}
											<label for="trialClassExpiryVal">Expire after how long without use (max 7 days):</label>
											<input value="10" id="trialClassExpiryVal" type="number" min="1" required/>
											<select id="trialClassExpiryDenom" required>
												<option value="minutes">Minutes</option>
												<option value="hours">Hours</option>
												<option value="days">Days</option>
											</select>
										{/if}
										{#if invExpiryType === 'length'}
											<label for="trialClassExpiryVal">Expire after how long (max 4 weeks):</label>
											<input value="10" id="trialClassExpiryVal" type="number" min="1" required/>
											<select id="trialClassExpiryDenom" required>
												<option value="minutes">Minutes</option>
												<option value="hours">Hours</option>
												<option value="days">Days</option>
												<option value="weeks">Weeks</option>
											</select>
										{/if}
										{#if invExpiryType === 'date'}
											<label for="trialClassExpiryVal">Expire when (max 90 days from now):</label>
											<input
													type="datetime-local"
													id="trialClassExpiryVal"
													value={dateTomorrow.toISOString().slice(0, -8)}
													min={dateTomorrow.toISOString().slice(0, -8)}
													max={dateThreeMonths.toISOString().slice(0, -8)} required/>
										{/if}

										<div>
											<Button type="submit" id="trialCreateConf" variant="raised">
												<span class="material-icons">post_add</span> Create trial classroom
											</Button>
										</div>
									</form>
									<div bind:this={tskBlbParents.trialClass}></div>

								</ViewTab>
							{/if}
							{#if hasEnrolls}
								<ViewTab label={isInstructor? "Student Enrollment" : "Your Progress"} {tabControl}>
									{#each studentProgressData as {class_id, class_name, instructor, instructor_contact, attempts}}
										<h2>{class_name}</h2>
										<p>
											Taught by {instructor}
											<a href={`mailto:${instructor_contact}`}>
												<button class="email-button"><span class="material-icons">email</span></button>
											</a>
										</p>
										<AttemptsTable {attempts}/>
										<br>
										<hr>
										<br>
									{/each}
								</ViewTab>
							{/if}
						</ViewTabSet>
					{:else}
						<h2>No Data</h2>
						<p>Make sure to <a href="/join">join your class</a> first if you've been enrolled by an instructor.</p>
						<p>Want to create your own classes? <a href="mailto:swodinschwartz@wpi.edu,ars027@bucknell.edu">Contact FBD Administration</a> to discuss instructor access to our program.</p>
					{/if}
					<br/>

				{/if}

			{:else}
				<h3>NOTE: Please sign in using your school email. These emails end with @wpi.edu for WPI students and @bucknell.edu for Bucknell students.</h3>
				<Button variant="raised" on:click={googleSignIn}><span class="material-icons">alternate_email</span>Sign In With Gmail</Button>
				<Button variant="raised" on:click={msSignIn}><span class="material-icons">window</span>Sign In With Microsoft (Organization)</Button>
			{/if}
			<br/>
			<br/>
			<p style="font-size: larger; font-weight: bold">Have an instructor's class to join on this device?</p>
			<p><a href="/invite" style="display: inline-block">Enroll with invite code</a> ⬦ <a href="/join" style="display: inline-block">Enroll with your email</a></p>

			<br>
			<p style="font-size: smaller"><a href="mailto:swodinschwartz@wpi.edu,ars027@bucknell.edu">Contact FBD Administration</a></p>

			<div style="display: none" bind:this={tskBlbParents.breakroom}>
				<div class={`invite-feedback ${taskStatusMap.getStyle(taskStatus)}`} bind:this={taskBlurbCard}>
					<p>{taskStatusMap.getBlurb(taskStatus)}</p>
					{#if taskNotifs}
						<div style="margin-top: 0.5em">
							<p>Info:</p>
							{#each taskNotifs as nc}
								<p class={"invite-notif " + taskStatusMap.getNotifStyle(nc)}>{taskStatusMap.getNotifText(nc)}</p>
							{/each}
						</div>
					{/if}
					{#if taskStatusMap.canRetry(taskStatus)}
						<br/>
						<form on:submit|preventDefault={() => taskAddrsRetryFn("blurbRevisedAddrsField")}>
							<label for="blurbRevisedAddrsField">Consider trying again with the revised recipient
								list below.</label>
							<input readonly class="invite-entry" value={taskRecs[0].join(' ')}
								   placeholder="e.g. bhoneydew@wpi.edu beaker@gmail.com"
								   id="blurbRevisedAddrsField" type="text"/>
							<div>
								<Button type="submit" id="revisedAddrsConf" variant="raised">
									Use these addresses
								</Button>
							</div>
						</form>
					{/if}
				</div>
			</div>

		</div>
	</AutoAdjust>
</main>

<style>
	/* Hide everything above this component. */
	:root {
		--mdc-theme-primary: #D7C7A1;
		--mdc-theme-text-primary-on-background: #020202;
		--mdc-theme-text-secondary-on-background: #020202;
		--mdc-theme-text-primary-on-light: #020202;
		--mdc-theme-text-secondary-on-light: #020202;
		--mdc-theme-on-primary: #020202;
		--mdc-theme-text-icon-on-background: #020202;
		--mdc-theme-background: #E6D6C1;
		--mdc-typography-font-family: AtlanticSlab;
	}

	:global(app),
	:global(body),
	:global(html) {
		color: #323232;
		background-color: #E6D6C1;
		background-image: url("/bg.jpg");
		background-size: 100vw;
		display: block !important;
		height: auto !important;
		width: auto !important;
		position: static !important;
		margin: 0 !important;
		padding: 0 !important;
		font-family: 'AnticSlab';
	}

	:global(app) {
		padding: 80px;
	}

	span.material-icons {
		margin-right: 0.15em;
	}

	main {
		text-align: center;
		padding: 0;
		margin: 0 auto;
	}

	h1 {
		text-transform: uppercase;
		font-size: 3em;
		font-weight: 300;
	}

	.appContainer {
		padding: 10vw !important;
		padding-top: 20px !important;
	}

	@media (min-width: 940px) {
		main {
			max-width: none;
		}

		.appContainer {
			padding: 10vw !important;
			padding-top: 150px !important;
		}
	}

	.consentText {
		margin-right: 0px;
		margin-left: 0px;
		padding: 10px;
		background-color: #AC8B64;
		border-radius: 5px;
		color: #323232;
	}

	.email-button {
		color: #333;
		background-color: #D7C7A1;
		border: none;

		padding: 0.4em 0.3em 0.3em 0.4em;

		border-radius: 5px;

		box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
		cursor: pointer;

		margin-left: 0.5em;
	}

	.email-button > * {
		font-size: 1.2em;
	}

	.invite-entry {
		display: block;
		width: 60vw;

		margin-left: auto;
		margin-right: auto;
	}

	.invite-checkbox {
		height: 1.5em;
		width: 1.5em;
		accent-color: #43a047;

		margin: 0.2em;
	}

	#blurbRevisedAddrsField {
		margin: 0.2em 0;
	}

	.invite-feedback {
		display: block;
		padding: 0.5em;

		color: #f4f4f4;
		font-size: larger;
		font-weight: bold;

		width: fit-content;
		min-width: 40%;
		border-radius: 20px;

		margin-left: auto;
		margin-right: auto;
	}

	.invite-feedback * {
		margin: 0;
	}

	.invite-feedback label {
		font-size: medium;
		font-weight: normal;
	}

	.invite-ok {
		background-color: #43a047;
	}

	.invite-warn {
		background-color: #AC8B64;
	}

	.invite-fail {
		background-color: #e53935;
	}

	.invite-notif {
		font-weight: normal;
	}

	.notif-notice:before {
		content: 'ⓘ\00FE0E\0020';
		font-size: larger;
		font-style: normal;
	}

	.notif-warning:before {
		content: '⚠\00FE0E\0020';
		font-size: larger;
		font-style: normal;
	}

	.notif-critical:before {
		content: '\0026D4\00FE0E\0020';
		font-size: larger;
		font-style: normal;
	}

	.notif-unknown:before {
		content: '⁇\00FE0E\0020';
		font-size: larger;
		font-style: normal;
	}

</style>